import React, { useState } from "react";
import DotsSpinner from "../../../components/Loader/DotsSpinner/DotsSpinner";
import { useHistory } from "react-router-dom";
import { IOverAllStudent, ITypeForTopTen } from "../../../types";
import ClickableCards from "../../../components/Cards/Dashboard/ClickableCards";

type Props = {
  stats: IOverAllStudent;
  isLoading: boolean;
  district: string;
  block?: string;
  week_no?: number;
  handleModalCLick ? : (e :ITypeForTopTen)=> void
};

const StudentTopTen = ({ stats, isLoading, district, block, week_no ,handleModalCLick }: Props) => {
  const history = useHistory();
  const [isOpenTopTenModal, setIsOpenTopTenModal] = useState<boolean>(false);
  const toggle = () => setIsOpenTopTenModal(!isOpenTopTenModal);
  return (
    <div className="my-2 ml-1">
          <div className="bg-primary  py-1 rounded flex-centered mt-5 ">
            {/* <h3 className="text-white m-0">Teacher Usage</h3> */}
            {/* <div className="bg-light opacity-50  rounded text-whit flex-centered px-1 py-3"> */}
            <span className="title text-white m-0">Top 10 Students</span>
          </div>
      {isLoading ? (
        <DotsSpinner />
      ) : (
        <>
          <div
            className="d-flex justify-content-between gap-5 py-4"
            style={{ gap: "4px" }}
          >
            <ClickableCards
              title={"Total App Usage ( in Min.)"}
              onClick={() => {
                stats?.Total_Usage
                  ? 
                   handleModalCLick({for:"student",type:"avgStudentUsage"})
                  //  history.push(
                  //   STATE_OFFICIAL_PATHS.topStateStudent +
                  //   "/avgStudentUsage" +
                  //   `/${district ? district : "all"}` +
                  //   `/${block ? block : "all"}` + 
                  //   `/${week_no ? week_no : "-1"}`
                  // )
                  : console.log("Data not available");
              }}
            />
            {/* <ClickableCards
              title={"Total time on Videos ( in Min.)"}
              onClick={() => {
                stats?.Total_time_videos
                  ? 
                  handleModalCLick({for:"student",type:"Total_time_videos"})
                  // history.push(
                  //   STATE_OFFICIAL_PATHS.topStateStudent +
                  //   "/Total_time_videos" +
                  //   `/${district ? district : "all"}` +
                  //   `/${block ? block : "all"}` +
                  //   `/${week_no ? week_no : "-1"}`
                  // )
                  : console.log("Total Time is not avelable");
              }}
            /> */}
            <ClickableCards
              title={"Total Homeworks / Assignments"}
              onClick={() => {
                stats?.Total_Assessments
                  ? handleModalCLick({for:"student",type:"Total_Assignments"})
                  // history.push(
                  //   STATE_OFFICIAL_PATHS.topStateStudent +
                  //   "/Total_Assignments" +
                  //   `/${district ? district : "all"}` +
                  //   `/${block ? block : "all"}` +
                  //   `/${week_no ? week_no : "-1"}`
                  // )
                  : console.log("Data not available");
              }}
            />
            <ClickableCards
              title={"Total Remedial Tests Taken"}
              onClick={() => {
                stats?.Total_Remedial
                  ? 
                  handleModalCLick({for:"student",type:"Avg_Remedial"})
                  // history.push(
                  //   STATE_OFFICIAL_PATHS.topStateStudent +
                  //   "/Avg_Remedial" +
                  //   `/${district ? district : "all"}` +
                  //   `/${block ? block : "all"}` +
                  //   `/${week_no ? week_no : "-1"}`
                  // )
                  : console.log("Data not available");
              }}
            />
            {/* <ClickableCards
              title={"Total Queries Raised"}
              onClick={() => {
                stats?.Total_queries_raised
                  ?
                  handleModalCLick({for:"student",type:"Total_queries_raised"})
                  //  history.push(
                  //   STATE_OFFICIAL_PATHS.topStateStudent +
                  //   "/Total_queries_raised" +
                  //   `/${district ? district : "all"}` +
                  //   `/${block ? block : "all"}` +
                  //   `/${week_no ? week_no : "-1"}`
                  // )
                  : console.log("Data not available");
              }}
            />
            <ClickableCards
              title={"Total Queries Resolved"}
              onClick={() => {
                stats?.Total_queries_solved
                  ? 
                  handleModalCLick({for:"student",type:"Total_queries_solved"})
                  // history.push(
                  //   STATE_OFFICIAL_PATHS.topStateStudent +
                  //   "/Total_queries_solved" +
                  //   `/${district ? district : "all"}` +
                  //   `/${block ? block : "all"}` +
                  //   `/${week_no ? week_no : "-1"}`
                  // )
                  : console.log("Data not available");
              }}
            /> */}
          </div>

          {/* <div className="bg-primary  py-1 rounded flex-centered mt-4 ">
            <span className="title text-white m-0">Others Statistics</span>
          </div>
          <div
            className=" d-flex justify-content-between py-4"
            style={{ gap: "6px" }}
          >
            <DashboardStatCard
              title={"Total Homeworks / Assignments"}
              stats={
                stats?.Total_Assessments
                  ? `${CommaSeparator(stats?.Total_Assessments)}`
                  : "0"
              }
              icon={""}
              onClick={() => {
                stats?.Total_Assessments
                  ? history.push(
                    STATE_OFFICIAL_PATHS.topStateStudent +
                    "/Total_Assignments" +
                    `/${district ? district : "all"}` +
                    `/${block ? block : "all"}`
                  )
                  : console.log("Data not available");
              }}
            />
            <DashboardStatCard
              title={"Avg Homeworks / Assignments per Student"}
              stats={
                stats?.Total_Assessments
                  ? `${(+stats?.Total_Assessments / +stats?.ActiveStudent).toFixed(2)}`
                  : "0"
              }
              icon={""}
            />
            <DashboardStatCard
              title={"Total Remedial Tests Taken"}
              stats={
                stats?.Total_Remedial
                  ? `${CommaSeparator(+stats?.Total_Remedial)}`
                  : "0"
              }
              icon={""}
              onClick={() => {
                stats?.Total_Remedial
                  ? history.push(
                    STATE_OFFICIAL_PATHS.topStateStudent +
                    "/Avg_Remedial" +
                    `/${district ? district : "all"}` +
                    `/${block ? block : "all"}`
                  )
                  : console.log("Data not available");
              }}
            />
            <DashboardStatCard
              title={"Avg Remedial Tests Taken per Student"}
              stats={
                stats?.Total_Remedial
                  ? `${(+stats?.Total_Remedial / +stats?.ActiveStudent).toFixed(0)}`
                  : "0"
              }
              icon={""}
            />
            <DashboardStatCard
              title={"Total Queries Raised"}
              stats={
                stats?.Total_queries_raised
                  ? CommaSeparator(+stats?.Total_queries_raised)
                  : "0"
              }
              icon={""}
              onClick={() => {
                stats?.Total_queries_raised
                  ? history.push(
                    STATE_OFFICIAL_PATHS.topStateStudent +
                    "/Total_queries_raised" +
                    `/${district ? district : "all"}` +
                    `/${block ? block : "all"}`
                  )
                  : console.log("Data not available");
              }}
            />
            <DashboardStatCard
              title={"Total Queries Resolved"}
              stats={
                stats?.Total_queries_solved
                  ? CommaSeparator(+stats?.Total_queries_solved)
                  : "0"
              }
              icon={""}
              onClick={() => {
                stats?.Total_queries_solved
                  ? history.push(
                    STATE_OFFICIAL_PATHS.topStateStudent +
                    "/Total_queries_solved" +
                    `/${district ? district : "all"}` +
                    `/${block ? block : "all"}`
                  )
                  : console.log("Data not available");
              }}
            />
          </div> */}
        </>
      )}
    </div>
  );
};
export default StudentTopTen;
